<template>
  <div class="choice-vote">
    <div v-for="(item,index) in showItems" :key="item.id" class="choice-vote-item">
      <div class="vote-rank-box">
        <img v-if="item.num<4" :src="'/assets/img/vote/'+item.num +'.png'" width="20" />
        <template v-else>
          <span>{{ item.num }}</span>
        </template>
      </div>
      <div class="choice-vote-content">
        <div class="choice-vote-title">
          <div>
            <div v-html="item.content.richText"></div>
          </div>
          <div class="vote-num-box">
            <span class="vote-num">{{ item.voteNum }}</span>
            <span>票</span>
          </div>
        </div>
        <div>
          <custom-progress :percentage="item.percentage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomProgress from './CustomProgress.vue'

export default {
  name: 'ChoiceVoteContent',
  components: { CustomProgress },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    showCount: {
      type: Number,
      default: 5
    }
  },
  computed: {
    showItems() {
      if (this.showCount < 0) return this.items
      return this.items.slice(0, this.showCount)
    }
  }
}
</script>

<style scoped>

</style>